{
  "line1": "Address",
  "line2": "Address Line 2",
  "city": "City",
  "state": "State",
  "region": "State, county, province, or region",
  "postalCode": "Zip/Postal Code",
  "country": "Country"
}
